/** Participant statuses that represent afbud / cancellation (not occupying a seat). */
const AFBUD_PARTICIPATION_STATUSES = new Set([
  'cancellation',
  'afbud',
  'cancelled',
]);

export function isAfbudParticipationStatus(
  status: string | null | undefined
): boolean {
  const normalized = (status ?? '').trim().toLowerCase();
  return AFBUD_PARTICIPATION_STATUSES.has(normalized);
}
